<template>
  <span class="app-logo" role="img" aria-label="ClearBank" />
</template>

<style scoped lang="scss">
.app-logo {
  display: block;
  width: 98px;
  aspect-ratio: 340 / 59;
  background-color: $color-base-contrast;
  mask: url('../assets/logos/clear-bank-logo.png') center / contain no-repeat;
}
</style>
